import Vue from 'vue'
import Router from 'vue-router'
import home from 'views/home'
import filmSelfPrinter from 'views/filmSelfPrinter'
import fujiFilm from 'views/fujiFilm'
import blankPage from 'views/blankPage'
import cloudFilm from 'views/cloudFilm'
import hospitalPacs from 'views/hospitalPacs'
import areaHospitalLink from 'views/areaHospitalLink'
import cloudStation from 'views/cloudStation'
import aboutOur from 'views/aboutOur'
import helpIntro from 'views/help'
import questions from 'views/help/questions'
import agreement from 'views/help/agreement'
import complaints from 'views/help/complaints'
import video from 'views/help/video'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/filmSelfPrinter',
      name: 'filmSelfPrinter',
      component: filmSelfPrinter
    },
    {
      path: '/fujiFilm',
      name: 'fujiFilm',
      component: fujiFilm
    },
    {
      path: '/blankPage',
      name: 'blankPage',
      component: blankPage
    },
    {
      path: '/cloudFilm',
      name: 'cloudFilm',
      component: cloudFilm
    },
    {
      path: '/hospitalPacs',
      name: 'hospitalPacs',
      component: hospitalPacs
    },
    {
      path: '/areaHospitalLink',
      name: 'areaHospitalLink',
      component: areaHospitalLink
    },
    {
      path: '/cloudStation',
      name: 'cloudStation',
      component: cloudStation
    },
    {
      path: '/aboutOur',
      name: 'aboutOur',
      component: aboutOur
    },
    {
      path: '/helpIntro',
      name: 'helpIntro',
      component: helpIntro
    },
    {
      path: '/questions',
      name: 'questions',
      component: questions
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement
    },
    {
      path: '/complaints',
      name: 'complaints',
      component: complaints
    },
    {
      path: '/video',
      name: 'video',
      component: video
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js